module.exports = __webpack_public_path__ + "static/media/p75.5f214861.jpg";